import React, { Fragment, useState } from "react";
import { Helmet } from "react-helmet";
import CommonFrom from "../../../../Common/Components/Form";
import { useRules } from "../Hooks";
function Create() {
  const { create, loading } = useRules();
  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | ثبت نقش</title>
      </Helmet>
      <CommonFrom
        form={input}
        loading={loading.create}
        header="ایجاد نقش"
        textbtn="لیست نقش ها"
        linkbtn="/Admin/Rules"
        btnName="ایجاد نقش"
        submit={create}
        textEditor={"content"}
      />
    </Fragment>
  );
}

export const input = [
  {
    label: "عنوان نقش",
    size: "col-md-12",
    classNames: "mt-2",
    placeholder: "",
    name: "title",
    value: "",
  },
  {
    label: "انتخاب نوع ",
    size: "col-md-12",
    classNames: "mt-2",
    placeholder: "",
    name: "type",
    input: "select",
    options: [
      { id: "", name: "انتخاب کنید" },
      { id: "users", name: "برای کاربران" },
      { id: "admins", name: "برای ادمین ها" },
    ],
  },
];

export default Create;
